<template>
   <div id="landing">
      <div class="splash">
         <div class="splash-logo">
            <img src="../../assets/mobkast-logo-text.png" class="text-logo">
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Landing',
   components: {},
   data () {
      return {
         msg: '',
         copyrightYear: (new Date()).getFullYear(),
         investorLabelVisible: true,
         investorContactVisible: false,
      }
   },
   computed: {
      investorLabel: function() {
         if (!this.investorContactVisible) {
            return 'INVESTORS'
         } else {
            // To avoid spam crawlers
            const team = 'investor';
            const domain = 'mobkast';
            const tld = 'com';
            return team + '@' + domain + '.' + tld;
         }
      }
   },
   methods: {
      preventMouseDown: (e) => {},
      switchToInvestorContact: function(ev) {
         this.investorLabelVisible = false;
         var vm = this;
         setTimeout(function() {
            vm.investorContactVisible = true;
         }, 1000);
      },
      navigateToDashX: (ev) => {
         window.location = 'https://www.dashx.co';
      },
      scrollToElement: function(el) {
         this.$nextTick( function () {
            this.$scrollTo(el);
         });
      }
   }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* + General Page Style */
#landing { 
   height: 100svh;
   overflow-x: hidden;
   overflow-y: hidden;
   -webkit-overflow-scrolling: touch;   
}

/* - General Page Style */

/* + Splash Page */
.splash {
   display: grid;
   grid-template-rows: 50% 50%;
   background-color: #fdfdfd; /* Color background light white */
   /*#94131D; /* COLOR Mobkast Red */
   height: 100vh;
}

.splash-logo {
   display: flex;
   justify-content: center; /* Centers horizontally */
   align-items: center;     /* Centers vertically */
   height: 100vh;           /* Ensures the page takes up the full screen height */
   margin: 0;                /* Removes default browser spacing */
}

.scroll-indicator {
   width: 32px;
   cursor: pointer;
}

.text-logo {
   width: 106px;
}

::-webkit-scrollbar {
   display: none;
}

/* - Splash Page */

/* + Logo Row */
.logo-row {
   width: 64rem;   
   text-align: center;
   margin: auto;
   margin-top: 10rem;
}

.logo-landing {
   width: 164px;
   height: 164px;
}

.product-name {
   font-size: 0.96rem;
   text-shadow: 1px 1px 2px #BBB;
}

/* - Logo Row */

/* + Common Styles */
.mk-deep-red {
   color: #94131D; /* COLOR Mobkast Deep Red */
}

a, u {
   text-decoration: none;
   -webkit-tap-highlight-color: transparent;
   outline: none;
}

a {
   color: black;
   cursor: pointer;
}
/* - Common Styles */


/* + Responsive UI */
@media screen and (max-width: 960px) {
   .logo-row {
      width: auto;
   }
}

@media screen and (max-width: 640px) {
   .splash {
      grid-template-rows: 60% 40%;
      height: 100vh;
   }

   .offerings-row {
      padding-top: 0rem;
   }   
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/Landing.vue